<template>
  <div>
    <BlackBoxToolCard :key="forceUpdateKey" :card-name="tr('Pathology')" :payload="payload">
    </BlackBoxToolCard>
  </div>
</template>


<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { pathdsRoute } from '@/settings'
import BlackBoxToolCard from '../../../cards/BlackBoxToolCard/BlackBoxToolCard.vue'

const store = useStore()
const forceUpdateKey = ref(0)
const tr = (x) => x

const selectedAccessionNumber = computed(() => store.getters.selectedPathologyObject?.accessionNumber || '')

const baseUrl = pathdsRoute
const computedUrl = computed(() => {
  if (!selectedAccessionNumber.value) { return '' }
  return `${baseUrl}/viewer/biopsy/${selectedAccessionNumber.value}.html`
})

const payload = computed(() => {
  if (!computedUrl.value) { return { data: {}, url: {} } }
  return {
    data: {},
    url: {
      baseUrl: computedUrl.value,
      method: 'GET',
      queryParams: {},
    },
  }
})

// When the accession number in the Vuex store changes (user selects a new
// thumbnail in the UI) force a re-render by increasing the key's value bound to the
// custom component in the template.
watch(
  () => selectedAccessionNumber.value,
  (newValue, oldValue) => {
    if (newValue === oldValue) { return }
    forceUpdateKey.value++
  },
  { deep: true },
)
</script>
